// @ts-check
/**
 * @file PasswordField.jsx
 * @location src/components/auth/PasswordField.jsx
 * @role 비밀번호 입력 — 표시/숨기기 토글 포함.
 *   min-length 가드는 호출자(LoginScreen 등) 책임 (단순 controlled input).
 */
import { useState } from 'react';

/**
 * @param {{
 *   value: string,
 *   onChange: (v: string) => void,
 *   id?: string,
 *   autoComplete?: string,
 *   placeholder?: string,
 *   label?: string,
 * }} props
 */
export function PasswordField({
  value,
  onChange,
  id = 'auth-password',
  autoComplete = 'current-password',
  placeholder,
  label = '비밀번호',
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="password-field">
      <label className="flabel" htmlFor={id}>
        {label}
      </label>
      <div className="password-row">
        <input
          id={id}
          className="finput"
          type={show ? 'text' : 'password'}
          value={value}
          autoComplete={autoComplete}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className="password-toggle"
          aria-label={show ? '숨기기' : '표시'}
          onClick={() => setShow((s) => !s)}
        >
          {show ? '숨기기' : '표시'}
        </button>
      </div>
    </div>
  );
}
